var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.engage",
  title: "EGT Platform — Engage",
  description: "Loyalty your customers won't resent — opt-in, transparent, never a nag.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "engage", reserve: reserve,
    media: { img: "/imgs/egt-platform-engage.jpg", alt: "", parallax: 0.06 },
    eyebrow: "The Universe Platform · Engage",
    title: [ "Loyalty your customers ", { n: "br" }, "won't ", { n: "span", c: "egt__gold", i: "resent." } ],
    lead: "Appreciation given, not extracted — opt-in, transparent, and easy to leave. No countdown timers, no streaks about to break.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Engage is the loyalty program inside the Universe Platform by EGT — opt-in points, status and rewards that thank returning customers without pressuring them, for businesses that would rather earn a return visit than force one. It's part of the public beta.",
    forTitle: "For businesses that want regulars, earned honestly.",
    forWho: [
      { title: "Businesses with returning customers", copy: "Give regulars a real reason to come back — appreciation they can see, for visits they chose to make." },
      { title: "Brands that refuse dark patterns", copy: "No countdown timers, no streaks about to break, no manufactured fear of missing out." },
      { title: "Customers who like clear rules", copy: "Points, status and rewards are transparent — what they earn and why is never hidden." }
    ],
    faq: [
      [ "Is anyone enrolled automatically?",
        "No. Customers choose to join and can leave in a single tap. Nobody is enrolled by surprise or held by guilt." ],
      [ "Can customers see how their rewards work?",
        "Yes. Points, status and rewards are transparent — what they earn and why is never hidden behind a confusing scheme." ],
      [ "Can I export my data and leave?",
        "Yes. Your customers, orders, content and email list are yours, held as a grant, not a copy. Export them and walk anytime — an integrated core shouldn't mean a locked door." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "A thank-you, not a trap.",
    spineLead: "Most loyalty programs are built to pressure people. This one is built to respect them — and it still works better for it.",
    points: [
      { title: "Opt-in, always", copy: "Customers choose to join and can leave in a single tap. Nobody is enrolled by surprise or held by guilt." },
      { title: "No dark patterns", copy: "No artificial urgency, no streak-anxiety, no manufactured fear of missing out. Just real appreciation for coming back." },
      { title: "Theirs to see", copy: "Points, status, and rewards are transparent — what they earn and why is never hidden behind a confusing scheme." }
    ],
    honesty: "Built on respect, not pressure.",
    honestyLead: "A loyalty program you'd actually be proud to offer — appreciation given, never extracted.",
    honestyMedia: { img: "/imgs/egt-platform-engage.jpg", alt: "", parallax: true }
  });
};
